var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoclient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2642 38.3614H22.9235V25.5708H13.2642V38.3614Z",
    fill: "#7E63D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3293 23.4175H22.9235V15.7318H11.3293V23.4175Z",
    fill: "#7E63D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0771 23.4175H36.6713V15.7318H25.0771V23.4175Z",
    fill: "#7E63D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0771 38.3614H34.7372V25.5708H25.0771V38.3614Z",
    fill: "#7E63D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8249 25.5706H36.8908V40.5155H11.1092V25.5706H9.17506V13.5769H14.7896C14.4706 12.9918 14.2885 12.3212 14.2885 11.6082C14.2885 9.33459 16.1386 7.48518 18.4115 7.48518C20.0929 7.48518 21.8132 8.35341 23.1325 9.86894C23.4593 10.2438 23.7501 10.6468 24 11.0661C24.2506 10.6461 24.5428 10.2438 24.8682 9.86894C26.1854 8.35412 27.9071 7.48518 29.5885 7.48518C31.8614 7.48518 33.7115 9.33459 33.7115 11.6082C33.7115 12.3212 33.5294 12.9918 33.2096 13.5769H38.8249V25.5706ZM24 0C10.7456 0 0 10.7456 0 24C0 37.2536 10.7456 48 24 48C37.2544 48 48 37.2536 48 24C48 10.7456 37.2551 0 24 0Z",
    fill: "#7E63D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4118 13.5764C17.3262 13.5764 16.4431 12.6934 16.4431 11.6077C16.4431 10.5221 17.3262 9.63904 18.4118 9.63904C20.3678 9.63904 22.2243 11.6381 22.7664 13.5764H18.4118Z",
    fill: "#7E63D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5574 11.6077C31.5574 10.5221 30.6744 9.63904 29.5887 9.63904C27.6334 9.63904 25.7755 11.6381 25.2341 13.5764H29.5887C30.6744 13.5764 31.5574 12.6934 31.5574 11.6077Z",
    fill: "#7E63D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoclient);
export default __webpack_public_path__ + "static/media/goclient.318e11e0.svg";
export { ForwardRef as ReactComponent };